import "./instructors.css";

import Instructor1 from "../../../Assets/Images/home/tt1.png";
import Instructor2 from "../../../Assets/Images/home/tt2.png";
import Instructor3 from "../../../Assets/Images/home/tt3.png";
import { useNavigate } from "react-router-dom";

const Instructors = () => {
  const navigate = useNavigate();
  return (
    <section className="instructors-section">
      <div className="container">
        <h2 className="instructors-title text-clip">OUR INSTRUCTORS</h2>

        <div className="instructors-grid">
          <div className="instructor-card">
            <img src={Instructor1} alt="Instructor" />
            <div className="instructor-name">
              <h3 className="inst-name">BASIM ERZOUKI</h3>
              <p className="inst-role">Head Instructor</p>
            </div>
          </div>

          <div className="instructor-card">
            <img src={Instructor2} alt="Instructor" />
            <div className="instructor-name">
              <h3 className="inst-name">LOGAN DALY</h3>
              <p className="inst-role">Head Instructor</p>
            </div>
          </div>

          <div className="instructor-card">
            <img src={Instructor3} alt="Instructor" />
            <div className="instructor-name">
              <h3 className="inst-name">JALEN SAYAMAN</h3>
              <p className="inst-role">Head Instructor</p>
            </div>
          </div>
        </div>

        <button className="inst-view-btn" onClick={() => navigate("/about/")}>
          <span className="text-clip">View All Instructors</span>
        </button>
      </div>
    </section>
  );
};

export default Instructors;
